import { useMutation, useQueryClient } from "@tanstack/react-query";
import { forceDeleteOrgStructureItem as apiFn } from "../../api/apiOrgStructureItems";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useForceDeleteOrgStructureItem() {
    const qc = useQueryClient(); const { enqueueSnackbar } = useSnackbar();
    const { mutate: forceDeleteOrgStructureItem, isPending: isForceDelete } = useMutation({
        mutationFn: (id) => apiFn(id),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); qc.invalidateQueries({ queryKey: ["orgStructureItems"] }); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); },
    });
    return { forceDeleteOrgStructureItem, isForceDelete };
}
